import { useSavedChartsStore } from '@/stores/savedChartsStore';
import { fetchSampleChartStyleGroups } from '@/composables/fetchSampleChartStyleGroups';
import { parseSampleChartStyleGroups } from '@/composables/parseSampleChartStyleGroups';

let initializeSampleChartStyleGroupsPromise: Promise<void> | null = null;

async function _initializeSampleChartStyleGroups() {
  const savedChartsStore = useSavedChartsStore();

  if (savedChartsStore.sampleChartStyleGroups.length) {
    return;
  }

  try {
    const rawSampleChartStyleGroups = await fetchSampleChartStyleGroups();
    const sampleChartStyleGroups = parseSampleChartStyleGroups(rawSampleChartStyleGroups);

    savedChartsStore.$patch({ sampleChartStyleGroups });
  } catch (e) {
    window.sc3WorkbenchLogger.error('Failed to initialize sample ChartStyle groups.', e);
  }
}

export async function initializeSampleChartStyleGroups() {
  let promiseObject;

  if (initializeSampleChartStyleGroupsPromise) {
    // there's already a request to initialize the sample ChartStyle groups underway
    // - await the current request's promise rather than kicking off a new request
    promiseObject = initializeSampleChartStyleGroupsPromise;
  } else {
    promiseObject = _initializeSampleChartStyleGroups();

    // store promise so that additional initializeSampleChartStyleGroups function
    // calls that are made while the current network call is still underway can
    // await this promise rather than inefficiently making their own duplicate
    // network requests for the same data
    initializeSampleChartStyleGroupsPromise = promiseObject;

    promiseObject.then(() => {
      // remove the now-resolved promise from the cache
      initializeSampleChartStyleGroupsPromise = null;
    });
  }

  await promiseObject;
}
